import { computed } from 'vue'
import type { FilterDefinition } from '@app/insights/types'
import { useSubmissionsStore } from '@app/insights/store/submissions'
import { useFiltersStore } from '@app/insights/store/filters'

export function useFilterVisibility(): {
  isFilterVisible: (definition: FilterDefinition) => boolean
} {
  const submissionsStore = useSubmissionsStore()
  const filtersStore = useFiltersStore()

  const filtersContext = computed(() => ({
    submissionData: submissionsStore.submissionData,
    dropdownValues: filtersStore.filterDropdownValues,
  }))

  function isFilterVisible(definition: FilterDefinition): boolean {
    if (definition.shouldShow)
      return definition.shouldShow(filtersContext.value)

    return true
  }

  return { isFilterVisible }
}
